import React from 'react';
import { Fragment, useState } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { XMarkIcon } from '@heroicons/react/24/outline'
import { NavLink } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { removeItem } from '../../redux/slice/cartSlice';

const products = [
    {
        id: 1,
        name: 'Throwback Hip Bag',
        href: '#',
        color: 'Salmon',
        price: '$90.00',
        quantity: 1,
        imageSrc: 'https://tailwindui.com/img/ecommerce-images/shopping-cart-page-04-product-01.jpg',
        imageAlt: 'Salmon orange fabric pouch with match zipper, gray zipper pull, and adjustable hip belt.',
    },
    {
        id: 2,
        name: 'Medium Stuff Satchel',
        href: '#',
        color: 'Blue',
        price: '$32.00',
        quantity: 1,
        imageSrc: 'https://tailwindui.com/img/ecommerce-images/shopping-cart-page-04-product-02.jpg',
        imageAlt:
            'Front of satchel with blue canvas body, black straps and handle, drawstring top, and front zipper pouch.',
    },
    // More products...
]

const Cart = () => {
    const [open, setOpen] = useState(true)
    const { cart, toalaQuantity, TotalPrice } = useSelector(state => state.carts)
    const totalPrice = cart.reduce((a, b) => a + b.quantity * b.price, 0)
    // console.log(cart)

    const dispatch = useDispatch()

    return (
        <div>
            <div style={{ width: '80%', margin: '0rem auto', padding: '1rem' }}>
                <div className="mt-8">
                    <div className="flow-root">
                        <ul role="list" className="-my-6 divide-y divide-gray-200">
                            {cart.map((product) => (
                                <li key={product.id} className="flex py-6">
                                    <div className="h-24 w-24 flex-shrink-0 overflow-hidden rounded-md border border-gray-200">
                                        <img
                                            src={product.images[0]}
                                            alt={product.images[0]}
                                            className="h-full w-full object-cover object-center"
                                        />
                                    </div>

                                    <div className="ml-4 flex flex-1 flex-col">
                                        <div>
                                            <div className="flex justify-between text-base font-medium text-gray-900">
                                                <h3>
                                                    <p className="text-gray-500"> {product.title}</p>
                                                </h3>
                                                <div className="flex justify-between text-base font-medium text-gray-100" style={{ width: '15rem', color: 'green' }}>
                                                    <p className="text-gray-500" style={{ color: 'green' }}>{product.description}</p>
                                                </div>
                                                <p className="ml-4">${product.price}</p>
                                            </div>
                                            <p className="text-gray-500"> {product.brand}</p>


                                        </div>


                                        <div className="flex flex-1 items-end justify-between text-sm">

                                            <p className="text-gray-500">Qty : {product.quantity}</p>

                                            <div className="flex">
                                                <button

                                                    onClick={() => dispatch(removeItem(product.id))}
                                                    type="button"
                                                    className="font-medium text-indigo-600 hover:text-indigo-500"
                                                >
                                                    Remove
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            ))}
                            <br />
                        </ul>
                    </div>
                </div>
                <div className="border-t border-gray-200 px-4 py-6 sm:px-6">
                    <div className="flex justify-between text-base font-medium text-gray-900">
                        <p>Subtotal</p>
                        <p>${totalPrice}</p>
                    </div>
                    <p className="mt-0.5 text-sm text-gray-500">Shipping and taxes calculated at checkout.</p>
                    <div className="mt-6">
                        <NavLink
                            to="/cart/order"
                            className="flex items-center justify-center rounded-md border border-transparent bg-indigo-600 px-6 py-3 text-base font-medium text-white shadow-sm hover:bg-indigo-700"
                        >
                            pay and order
                        </NavLink>
                    </div>
                    <div className="mt-6 flex justify-center text-center text-sm text-gray-500">
                        <p>
                            or&nbsp;
                            <button
                                type="button"
                                className="font-medium text-indigo-600 hover:text-indigo-500"
                                onClick={() => setOpen(false)}
                            >
                                <NavLink to='/'>
                                    Continue Shopping
                                </NavLink>
                                <span aria-hidden="true"> &rarr;</span>
                            </button>
                        </p>
                    </div>
                </div>

            </div>
        </div>

    )
}

export default Cart;